import * as React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';

import { getSectionNavLightColor } from 'styles/helpers/getThemeStyles';

const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  fill: getSectionNavLightColor(theme)
}));

const StyledIconButton = styled(IconButton)({
  position: 'initial'
});

export function CloseButton({ IconProps = {}, ...rest }) {
  return (
    <StyledIconButton autoFocus aria-label="Close" {...rest}>
      <StyledCloseIcon {...IconProps} />
    </StyledIconButton>
  );
}

CloseButton.propTypes = {
  IconProps: PropTypes.object
};
